import React, { useState, useEffect } from "react";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Select from "react-select";
import { checkboxData } from "./checkboxData";
import "./style.css";
import { useUserAuth } from "../../context/UserAuthContext";
import { useFormik } from "formik";
import { birthdayClubbingTtkSchema } from "../schemas";
import axios from "axios";
import { NumericFormat } from "react-number-format";
import ThinksToKnowStatus from "./ThinksToKnowStatus";

const BirthadayClubingTTK = () => {
  const { language, token, currency } = useUserAuth();
  const workingSinceOption = checkboxData.workSinceOption;
  const spaceOption = checkboxData.spaceOption;
  const smallPartiesOption = checkboxData.smallPartyOption;
  const parkingOption = checkboxData.parkingOption;
  const { user } = useUserAuth();
  const merchant_id = user.uid;
  const base_url = import.meta.env.VITE_LOCAL_BASE_URL;
  const [merchant, setMerchant] = useState({});
  const getSingleDocumentHandler = async () => {
    try {
      const res = await axios.get(
        `${base_url}/api/v1/thinkstoknow/${merchant_id}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      const data = res.data.data;
      const details = data[0].details;
      // const details = rawDetails ? JSON.parse(rawDetails) : null;
      if (details) {
        setMerchant(details);
        // formik.setValues(details);
      }
    } catch (error) {
      console.log(`Error : ${error}`);
    }
  };
  useEffect(() => {
    if (!merchant_id) return;
    getSingleDocumentHandler();
  }, [merchant_id, token]);
  const formik = useFormik({
    initialValues: {
      parkingSize: merchant?.parkingSize || "",
      vegPrice: Math.floor(merchant?.vegPrice * currency.value) || "",
      nonVegPrice: Math.floor(merchant?.nonVegPrice * currency.value) || "",
      roomCount: merchant?.roomCount || "",
      maxCapicity: merchant?.maxCapicity || "",
      minCapicity: merchant?.minCapicity || "",
      workingSince: merchant?.workingSince || [],
      parking: merchant?.parking || [],
      smallPartiesVenue: merchant?.smallPartiesVenue || [],
      space: merchant?.space || [],
    },
    enableReinitialize: true,
    validationSchema: birthdayClubbingTtkSchema,
    onSubmit: async (values) => {
      try {
        const data = {
          id: merchant_id,
          details: {
            ...values,
            vegPrice: Math.floor(values.vegPrice * currency.country_value),
            nonVegPrice: Math.floor(values.nonVegPrice * currency.country_value),
          },
        };

        const res = await axios.post(`${base_url}/api/v1/thinkstoknow`, data, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });

        if (res.status === 201) {
          toast.success("Things to know added successfully.");
          setMerchant(values);
          formik.setValues(values);
          setTtkEditMode(false);
        } else if (res.status === 202) {
          toast.success("Your update is pending approval by the admin.");
          setTtkEditMode(false);
        } else {
          toast.info(res.data.message || "Request submitted.");
          setTtkEditMode(false);
        }
      } catch (error) {
        console.error(`Error ${error}`);
        toast.error("An error occurred while submitting the data.");
      }
    },
  });

  const [ttkEditMode, setTtkEditMode] = useState(false);
  return (
    <div className="page-wrapper">
      <div className="container-fluid">
         <ThinksToKnowStatus/>
        <div className="row">
          <div className="col-md-12">
            <div className="card">
              <div className="card-header bg-primary text-white">
                <h5>
                  {" "}
                  {language === "en"
                    ? "Things to Know"
                    : "जानने योग्य जानकारी भरे"}
                </h5>
              </div>
              <div className="card-body">
                {merchant && (
                  <>
                    <div className="table-responsive">
                      <table
                        className="table text-center"
                        cellPadding={0}
                        cellSpacing={0}
                        style={{ border: "1px solid #fff " }}
                      >
                        <tbody className="ttk_preview">
                          <tr style={{ color: "#41B0FA" }}>
                            <th style={{ width: "25%" }}>Start of Venue</th>
                            <th style={{ width: "25%" }}>Parking</th>
                            <th style={{ width: "25%" }}> Car Parking Space</th>
                            <th style={{ width: "25%" }}>Veg Price </th>
                          </tr>
                          <tr>
                            <td>
                              {merchant.workingSince?.map((item, index) => {
                                return <p key={index}>{item.value}</p>;
                              })}
                            </td>
                            <td>
                              {merchant.parking?.map((item, index) => {
                                return <p key={index}>{item.value}</p>;
                              })}
                            </td>
                            <td>{merchant.parkingSize}</td>
                            <td>
                              <NumericFormat
                                value={Math.floor(
                                  currency.value * merchant.vegPrice
                                )}
                                displayType="text"
                                thousandsGroupStyle={
                                  currency.symbol === "₹" ? "lakh" : "thousand"
                                }
                                thousandSeparator=","
                                renderText={(formattedValue) => (
                                  <span>
                                    {currency.symbol}&nbsp;{formattedValue}
                                  </span>
                                )}
                              />
                              <small
                                className="text-success"
                                style={{
                                  fontWeight: "bold",
                                }}
                              >
                                Per Plate
                              </small>
                            </td>
                          </tr>
                          <tr style={{ color: "#41B0FA" }}>
                            <th>Non Veg Price</th>
                            <th>Small Party Venue</th>
                            <th>Space</th>
                            <th>Room Counts </th>
                          </tr>
                          <tr>
                            <td>
                              <NumericFormat
                                value={Math.floor(
                                  currency.value * merchant.nonVegPrice
                                )}
                                displayType="text"
                                thousandsGroupStyle={
                                  currency.symbol === "₹" ? "lakh" : "thousand"
                                }
                                thousandSeparator=","
                                renderText={(formattedValue) => (
                                  <span>
                                    {currency.symbol}&nbsp;{formattedValue}
                                  </span>
                                )}
                              />
                              <small
                                className="text-success"
                                style={{
                                  fontWeight: "bold",
                                }}
                              >
                                Per Plate
                              </small>
                            </td>
                            <td>
                              {merchant.smallPartiesVenue?.map(
                                (item, index) => {
                                  return <p key={index}>{item.value}</p>;
                                }
                              )}
                            </td>
                            <td>
                              {merchant.space?.map((item, index) => {
                                return (
                                  <span key={index}>
                                    <i className="fa fa-check text-success" />
                                    <span>{item.value} </span>
                                  </span>
                                );
                              })}
                            </td>
                            <td>{merchant.roomCount}</td>
                          </tr>
                          <tr style={{ color: "#41B0FA" }}>
                            <th>Maximum Capicity</th>
                            <th>Minimum Capicity</th>
                          </tr>
                          <tr>
                            <td>{merchant.maxCapicity}</td>
                            <td>{merchant.minCapicity}</td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </>
                )}
                <center>
                  <button
                    className="btn btn-primary mb-2"
                    onClick={() => setTtkEditMode(!ttkEditMode)}
                  >{`${
                    merchant ? "Make Changes" : "Tell me more about yourself"
                  }`}</button>
                </center>
                {ttkEditMode && (
                  <form onSubmit={formik.handleSubmit}>
                    <div className="row">
                      <div className="col-md-6">
                        <div className="form-group">
                          <label>
                            Start of Venue{" "}
                            <span className="text-danger">*</span>
                          </label>
                          <Select
                            closeMenuOnSelect={false}
                            isMulti
                            options={workingSinceOption}
                            selected
                            value={formik.values.workingSince}
                            onChange={(workingSince) =>
                              formik.setFieldValue("workingSince", workingSince)
                            }
                            onBlur={formik.handleBlur}
                          />
                          {formik.touched.workingSince &&
                          formik.errors.workingSince ? (
                            <div className="text-danger">
                              {formik.errors.workingSince}
                            </div>
                          ) : null}
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="form-group">
                          <label>
                            Parking <span className="text-danger">*</span>
                          </label>
                          <Select
                            closeMenuOnSelect={false}
                            isMulti
                            options={parkingOption}
                            selected
                            value={formik.values.parking}
                            onChange={(parking) =>
                              formik.setFieldValue("parking", parking)
                            }
                            onBlur={formik.handleBlur}
                          />
                          {formik.touched.parking && formik.errors.parking ? (
                            <div className="text-danger">
                              {formik.errors.parking}
                            </div>
                          ) : null}
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="form-group">
                          <label>
                            How many cars can be parked at your Birthaday
                            Parties? <span className="text-danger">*</span>
                          </label>
                          <input
                            type="number"
                            placeholder="How many cars can be parked at your Parties?"
                            name="parkingSize"
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            value={formik.values.parkingSize}
                            className="form-control"
                          />
                          {formik.touched.parkingSize &&
                          formik.errors.parkingSize ? (
                            <div className="text-danger">
                              {formik.errors.parkingSize}
                            </div>
                          ) : null}
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="form-group">
                          <label>
                            Veg Price Per Plate
                            <span className="text-danger">*</span>
                          </label>
                          <input
                            type="number"
                            placeholder="Veg Price Per Plate"
                            name="vegPrice"
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            value={formik.values.vegPrice}
                            className="form-control"
                          />
                          {formik.touched.vegPrice && formik.errors.vegPrice ? (
                            <div className="text-danger">
                              {formik.errors.vegPrice}
                            </div>
                          ) : null}
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="form-group">
                          <label>
                            Non Veg Price Per Plate
                            <span className="text-danger">*</span>
                          </label>
                          <input
                            type="number"
                            placeholder="Non Veg Price Per Plate"
                            name="nonVegPrice"
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            value={formik.values.nonVegPrice}
                            className="form-control"
                          />
                          {formik.touched.nonVegPrice &&
                          formik.errors.nonVegPrice ? (
                            <div className="text-danger">
                              {formik.errors.nonVegPrice}
                            </div>
                          ) : null}
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="form-group">
                          <label>
                            Small Party Venue{" "}
                            <span className="text-danger">*</span>
                          </label>
                          <Select
                            closeMenuOnSelect={false}
                            isMulti
                            options={smallPartiesOption}
                            selected
                            value={formik.values.smallPartiesVenue}
                            onChange={(smallPartiesVenue) =>
                              formik.setFieldValue(
                                "smallPartiesVenue",
                                smallPartiesVenue
                              )
                            }
                            onBlur={formik.handleBlur}
                          />
                          {formik.touched.smallPartiesVenue &&
                          formik.errors.smallPartiesVenue ? (
                            <div className="text-danger">
                              {formik.errors.smallPartiesVenue}
                            </div>
                          ) : null}
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="form-group">
                          <label>
                            Space <span className="text-danger">*</span>
                          </label>
                          <Select
                            closeMenuOnSelect={false}
                            isMulti
                            options={spaceOption}
                            selected
                            value={formik.values.space}
                            onChange={(space) =>
                              formik.setFieldValue("space", space)
                            }
                            onBlur={formik.handleBlur}
                          />
                          {formik.touched.space && formik.errors.space ? (
                            <div className="text-danger">
                              {formik.errors.space}
                            </div>
                          ) : null}
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="form-group">
                          <label>
                            Room Count <span className="text-danger">*</span>
                          </label>
                          <input
                            type="number"
                            placeholder="Room Count"
                            name="roomCount"
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            value={formik.values.roomCount}
                            className="form-control"
                          />
                          {formik.touched.roomCount &&
                          formik.errors.roomCount ? (
                            <div className="text-danger">
                              {formik.errors.roomCount}
                            </div>
                          ) : null}
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="form-group">
                          <label>
                            Maximum Capicity
                            <span className="text-danger">*</span>
                          </label>
                          <input
                            type="number"
                            placeholder="Maximum Capicity"
                            name="maxCapicity"
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            value={formik.values.maxCapicity}
                            className="form-control"
                          />
                          {formik.touched.maxCapicity &&
                          formik.errors.maxCapicity ? (
                            <div className="text-danger">
                              {formik.errors.maxCapicity}
                            </div>
                          ) : null}
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="form-group">
                          <label>
                            Minimum Capicity{" "}
                            <span className="text-danger">*</span>
                          </label>
                          <input
                            type="number"
                            placeholder="Minimum Capicity"
                            name="minCapicity"
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            value={formik.values.minCapicity}
                            className="form-control"
                          />
                          {formik.touched.minCapicity &&
                          formik.errors.minCapicity ? (
                            <div className="text-danger">
                              {formik.errors.minCapicity}
                            </div>
                          ) : null}
                        </div>
                      </div>
                    </div>
                    <div className="form-group text-center">
                      <button className="btn btn-primary" type="submit">
                        {ttkEditMode ? "Save Changes" : "Submit"}
                      </button>
                    </div>
                  </form>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BirthadayClubingTTK;
